<template>
  <f7-page
    @page:beforein="beforein"
  >
    <navbar>
      <template
        v-slot:nav-title
        class="breadcrumbs"
      >
        <span
          class="breadcrumb-link"
          @click="$f7.views.main.router.navigate('/cockpit/', { reloadCurrent: true })"
        >
          {{ $t('Home_navbar_title') }}
        </span>
        <f7-icon class="icon-breadcrumb" />
        <span class="breadcrumb-title">{{ $t('LeftPanel_title_openProject') }}</span>
      </template>
    </navbar>
    <div v-if="selection === 'GreenHouse'">
      <ListProjectsGreenHouse
        :key="`gh-${key}`"
        :list-gh="listGh"
      />
    </div>
    <div v-else>
      <ListProjectsOpenAir
        :key="`ex-${key}`"
        :list-ex="listEx"
      />
    </div>
  </f7-page>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import navbar from '../../components/navbar/NavBar.vue';
import ListProjectsGreenHouse from '../../components/listProjects/listGreenHouse/index.vue';
import ListProjectsOpenAir from '../../components/listProjects/listOpenAir/index.vue';
import EventBus from '../../js/event-bus';

export default {
  name: 'ListProjects',
  components: {
    navbar,
    ListProjectsGreenHouse,
    ListProjectsOpenAir,
  },
  data() {
    return {
      key: 0,
    };
  },
  computed: {
    ...mapState('authentication', [
      'selection',
    ]),
    ...mapState('Database', [
      'listGh', 'listEx',
    ]),
  },
  beforeMount() {
    EventBus.$on('fetch-projects', this.beforein);
  },
  beforeDestroy() {
    EventBus.$off('fetch-projects');
  },
  methods: {
    async beforein() {
      this.$f7.preloader.show();
      try {
        await this.fetchProjects();
        this.key += 1;
      } catch (error) {
        this.$f7.dialog.alert(this.$t(`${error}`));
      } finally {
        this.$f7.preloader.hide();
      }
    },
    ...mapActions('Database', [
      'fetchProjects',
    ]),
  },
};
</script>
<style lang="scss" scoped>

</style>
